<template>
  <div class="page-layout">
    <div class="page-content">
      <h1>Уведомления</h1>
      <NotificationList
        :notifications="notifications"
        :loading="loading"
        @select="openNotification"
        @mark-all-read="markAllRead"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import NotificationList from '../components/NotificationList.vue'
import { fetchNotifications, markAllNotificationsRead, markNotificationRead } from '../api/notifications'

const router = useRouter()
const notifications = ref([])
const loading = ref(true)

async function loadNotifications() {
  loading.value = true
  try {
    notifications.value = await fetchNotifications()
  } finally {
    loading.value = false
  }
}

async function openNotification(notification) {
  if (!notification.read_at) {
    await markNotificationRead(notification.id)
    notification.read_at = new Date().toISOString()
  }
  if (notification.event_id) {
    router.push({ name: 'event', params: { id: notification.event_id } })
    return
  }
  if (notification.trip_id) {
    router.push({ name: 'trip', params: { id: notification.trip_id } })
    return
  }
  router.push({ name: 'track', params: { id: notification.track_id } })
}

async function markAllRead() {
  await markAllNotificationsRead()
  const now = new Date().toISOString()
  notifications.value = notifications.value.map((item) => ({ ...item, read_at: item.read_at || now }))
}

onMounted(loadNotifications)
</script>
